import axios from 'axios'
import { useState } from 'react'
import { apiStatus } from '../constants/apiStatus'
import { apiUrl, axiosDefaultHeader, baseUrl, stage } from '../constants/apiUrl'
import { loadStatus } from '../constants/loadStatus'
import { errorMsg } from '../constants/messages'
import type { Result } from '../interfaces/Result'
import { useAuth } from './useAuth'
import { useApiUrl } from './useApiUrl'

interface C703SignageUpdateProps {
  execSignageUpdate: (
    oldSignageName: string,
    newSignageName: string,
    file_body?: File,
    signed_url?: string,
  ) => Promise<Result>
  loading: loadStatus
}
// C703 サイネージ更新API呼出
export const useC703SignageUpdate = (): C703SignageUpdateProps => {
  const [loading, setLoading] = useState(loadStatus.NONE)
  const auth = useAuth()
 const { buildDeviceUrl } = useApiUrl()

  const execSignageUpdate = async (
    oldSignageName: string,
    newSignageName: string,
    file_body?: File,
    signed_url?: string,
  ) => {
    try {
      setLoading(loadStatus.LOADING)
      const jwt = await auth.getJwt()
      let body = {}
      if (jwt === '') {
        setLoading(loadStatus.LOADED)
        return { success: false, message: errorMsg.SESSION_ERROR }
      }
      // ヘッダ作成
      const header = Object.assign(axiosDefaultHeader, {
        Authorization: 'Bearer ' + jwt,
      })
      // console.log(header);

      // ボディ作成
      if (file_body) {
        body = {
          old_signage_name: oldSignageName,
          signage_name: newSignageName,
          language: 'ja',
          file_name: file_body.name,
          url: signed_url,
        }
      } else {
        body = { old_signage_name: oldSignageName, signage_name: newSignageName, language: 'ja' }
      }

      const response = await axios.put(
        buildDeviceUrl(auth.deviceId, apiUrl.signagesPath),
        body,
        {
          headers: header,
          validateStatus: () => true,
        },
      )

      if (response.status === apiStatus.SUCCESS) {
        setLoading(loadStatus.LOADED)
        return { success: true, info: response.data }
      }
      setLoading(loadStatus.LOADED)
      if (response.data && response.data.message) {
        return { success: false, message: response.data.message }
      }
      return { success: false, message: errorMsg.SYSTEM_ERROR }
    } catch (error) {
      setLoading(loadStatus.LOADED)
      return { success: false, message: errorMsg.SYSTEM_ERROR }
    }
  }

  return { execSignageUpdate, loading }
}